import { shape, string } from 'prop-types'

export const breadcrumbType = shape({
  label: string,
  href: string,
})
